import { render, staticRenderFns } from "./Cria_Corretor.vue?vue&type=template&id=24886e1d&scoped=true&"
import script from "./Cria_Corretor.vue?vue&type=script&lang=js&"
export * from "./Cria_Corretor.vue?vue&type=script&lang=js&"
import style0 from "./Cria_Corretor.vue?vue&type=style&index=0&id=24886e1d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24886e1d",
  null
  
)

export default component.exports